import {onFind, initInScope} from "@elements/init-modules-in-scope";
import {on, find, findAllIn, closest} from "@elements/dom-utils";
import axios from "axios";
import asyncAppend from "@elements/async-append";

export function init() {
    onFind('.js-planner-list-delete', function (deleteButton) {
        let list = find('.js-planner-list');

        on('click', () => {
            let pendingRequest = axios({method: 'POST', url: deleteButton.getAttribute('data-href') });

            console.log(pendingRequest.then((x) => x.data))
            console.log(findAllIn('.js-planner-list__result', list))

            asyncAppend({
                target: findAllIn('.js-planner-list__result', list),
                loading: findAllIn('.js-planner-list__loading', list)
            }, pendingRequest.then((x) => x.data));
        }, deleteButton);
    });

    onFind('.js-planner-list__share', function (button) {
        on('click', () => {
            let pendingRequest = axios({method: 'POST', url: button.getAttribute('data-share-link') }),
                col = closest('.js-planner-list__share-col', button);

            pendingRequest.then(({data}) => {
                col.innerHTML = data.content;

                initInScope(col);
            });
        }, button);
    });
}